module.exports = __webpack_public_path__ + "img/24_a_storm.da5e2884.jpg";